import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
import { refreshAdminUser } from '@/hooks/useAdminAuth';

export default function AdminLayout() {
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    refreshAdminUser();
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <AdminSidebar collapsed={collapsed} />
      <AdminHeader collapsed={collapsed} onToggle={() => setCollapsed((v) => !v)} />
      <main
        className={`transition-all duration-300 pt-16 min-h-screen ${
          collapsed ? 'ml-16' : 'ml-56'
        }`}
      >
        <div className="p-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
